// core version + navigation, pagination modules:
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperType } from 'swiper'; // Importa il tipo

// import Swiper and modules styles
import 'swiper/scss';
import 'swiper/scss/effect-cards'
import './home.scss'
import { useContext, useEffect, useRef, useState } from 'react';
import NavBarComp from '../../components/navbar/navbar';
import { CartContext, DataManagerContext } from '../../App';
import { Product } from '../../models/product';
import "swiper/modules";
import { Autoplay, EffectCards, EffectCoverflow, Navigation, Pagination } from 'swiper/modules';
export interface HomeProps {

}

function Home(props: HomeProps) {

    const dataManager = useContext(DataManagerContext)
    const cartContext = useContext(CartContext);
    const [products, setProducts] = useState<Product[]>([]);
    const [showToast, setShowToast] = useState(false);


    useEffect(() => {
        var promises = [];
        promises.push(dataManager.listProducts());
        promises.push(dataManager.getCart());
        Promise.all(promises)
            .then((responses: any) => {
                setProducts(responses[0]);
                cartContext.setCart(responses[1]);

            })
            .catch((err) => console.log(err))
    }, [])



    // Riferimento all'istanza di Swiper
    const swiperRef = useRef<SwiperType | null>(null);

    // Callback per il cambio di slide
    const handleSlideChange = (swiper: SwiperType) => {
        if (swiperRef.current) {
            window.location.hash = `p-${products[swiper.realIndex].id}`; // Imposta l'hash
        }
    };

    // Recupera l'indice dall'hash
    const getSlideIdFromHash = () => {
        const hash = window.location.hash;
        if (hash.startsWith('#p-')) {
            const id = parseInt(hash.replace('#p-', ''), 10);
            if (!isNaN(id)) {
                const index = products.findIndex((p: any) => { return p.id == id })
                if (index > -1) return index
            }
        }
        return 0; // Default

    }

    const getProductImage = (product: Product) => {
        if (product.images.length > 0) {
            return <img src={product.images[0].src} alt={product.images[0].alt} />
        }
        else return <img src="./images/placeholder.png" alt="placeholder prodotto" />
    }

    const getProductPrice = (product: Product) => {
        const price = (parseInt(product.prices.price) / 100).toFixed(2).replace('.', ',');
        return `${product.prices.currency_symbol} ${price}`
    }

    const addInCart = (product: Product) => {
        dataManager.addInCart(product, 1).then((cart) => {
            cartContext.setCart(cart);
            setShowToast(true);
        })
            .catch((err) => {
                console.log(err);
            })
    }

    return (
        <>
            <div className='home'>

                <NavBarComp active='home' nCart={cartContext.cart ? cartContext.cart.items_count : 0}></NavBarComp>

                <div className='container mt-3'>

                    <div className="row justify-content-md-center containerSlide">
                        <div className="col-12">
                            <div className="swiper-container">
                                {products.length > 0 && <Swiper
                                    onSwiper={(swiper: any) => (swiperRef.current = swiper)}
                                    onSlideChange={handleSlideChange}
                                    initialSlide={getSlideIdFromHash()}
                                    effect={'cards'}
                                    grabCursor={true}
                                    modules={[EffectCards]}
                                    cardsEffect={{
                                        rotate: true,
                                        slideShadows: true,
                                        perSlideOffset: 8,
                                        perSlideRotate: 1
                                    }}
                                    className="swiperProduct"
                                    loop={true} // se vuoi un loop continuo
                                >
                                    {products.map((product, index) => {
                                        return (
                                            <SwiperSlide key={index} className='d-flex'>

                                                <div id="product-detail" className='card'>

                                                    <div className='d-flex justify-content-center'>
                                                        {getProductImage(product)}
                                                    </div>

                                                    <p className="label text-center">{product.name}</p>
                                                    <div className="px-3 mb-2 ">
                                                        <p className="description" dangerouslySetInnerHTML={{ __html: product.short_description }}></p>
                                                        <div className="row d-flex align-items-center">
                                                            <div className="col col-4 ">
                                                                <p className="price m-0">{getProductPrice(product)}</p>
                                                            </div>
                                                            <div className="col col-8 d-flex justify-content-end">
                                                                <button className="btn btn-carrello" onClick={() => addInCart(product)}>
                                                                    AGGIUNGI AL CARRELLO
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                            </SwiperSlide>
                                        )
                                    })}

                                </Swiper>

                                }
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-md-center containerSlide">
                        <div className="col-12">
                            <Swiper
                                spaceBetween={30}
                                centeredSlides={true}
                                initialSlide={6}
                                slidesPerView={2}
                                loop={true}
                                breakpoints={{
                                    320: {
                                        slidesPerView: 3,
                                        spaceBetween: 10
                                    },
                                    // when window width is >= 480px
                                    480: {
                                        slidesPerView: 3,
                                        spaceBetween: 10
                                    },
                                    // when window width is >= 640px
                                    640: {
                                        slidesPerView: 5,
                                        spaceBetween: 40
                                    }
                                }}
                                autoplay={{
                                    delay: 2500,
                                    disableOnInteraction: false,
                                }}
                                pagination={{
                                    clickable: true,
                                }}
                                navigation={true}
                                modules={[Autoplay, Pagination, Navigation]}
                                className="brandswiper"
                            >
                                <SwiperSlide><img src='./images/brand/antinori.png'></img></SwiperSlide>
                                <SwiperSlide><img src='./images/brand/barone.png'></img></SwiperSlide>
                                <SwiperSlide><img src='./images/brand/bertani.png'></img></SwiperSlide>
                                <SwiperSlide><img src='./images/brand/bolling.png'></img></SwiperSlide>
                                <SwiperSlide><img src='./images/brand/cadel.png'></img></SwiperSlide>
                                <SwiperSlide><img src='./images/brand/cotarella.png'></img></SwiperSlide>
                                <SwiperSlide><img src='./images/brand/louis.png'></img></SwiperSlide>
                                <SwiperSlide><img src='./images/brand/mac.png'></img></SwiperSlide>
                                <SwiperSlide><img src='./images/brand/ornellaia.png'></img></SwiperSlide>
                                <SwiperSlide><img src='./images/brand/poggio.png'></img></SwiperSlide>
                                <SwiperSlide><img src='./images/brand/quinto.png'></img></SwiperSlide>
                                <SwiperSlide><img src='./images/brand/sanguido.png'></img></SwiperSlide>
                            </Swiper>
                        </div>
                    </div>
                </div>


                {
                    showToast &&
                    <div className='toast-container p-3 bottom-0 start-0 position-fixed'>
                        <div className="toast show  text-bg-success" role="alert" aria-live="assertive" aria-atomic="true">
                            <div className="d-flex">
                                <div className="toast-body">
                                    Prodotto aggiunto al carrello
                                </div>
                                <button type="button" className="btn-close btn-close-white me-2 m-auto" aria-label="Close" onClick={() => setShowToast(false)}></button>
                            </div>
                        </div>
                    </div>

                }
            </div>

        </>
    );
}

export default Home